"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _inputTitleStyles = require("./input-title-styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Title = function Title(_ref) {
  var title = _ref.title,
      color = _ref.color,
      subtitle = _ref.subtitle,
      required = _ref.required,
      error = _ref.error;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement(_inputTitleStyles.TitleContainer, null, /*#__PURE__*/_react.default.createElement(_inputTitleStyles.MainText, {
    color: color,
    error: error
  }, title), required && /*#__PURE__*/_react.default.createElement(_inputTitleStyles.RequiredSign, null, "*")), subtitle && /*#__PURE__*/_react.default.createElement(_inputTitleStyles.SubText, {
    error: error
  }, subtitle));
};

var _default = Title;
exports.default = _default;